import { Component, Input, OnInit } from '@angular/core';

import { BaseComponent } from '@leandredev/common_ng_14';
import { FileService } from 'src/app/services/file/file.service';
import { interfaces } from '@leandredev/dcbm-common-lib';
import { ApiService } from 'src/app/services/api/api.service';

@Component({
  selector: 'app-avatar-display',
  templateUrl: './avatar-display.component.html',
  styleUrls: ['./avatar-display.component.scss']
})
export class AvatarDisplayComponent extends BaseComponent implements OnInit {
  @Input() size: 'small' | 'big';
  @Input() picture: interfaces.IFile;

  private defaulAvatarLink = './assets/img/avatars/default.png';

  avatarLink = 'assets/img/avatars/default.png';

  static memoisedAvater: Map<string, string> = new Map();

  constructor(private apiService: ApiService, protected fileService: FileService) {
    super();
  }

  public ngOnInit(): void {
    if (this.picture) this.displayImg(this.picture);
  }

  public progress: { value: 0; mode: 'indeterminate' } = { value: null, mode: 'indeterminate' };

  public displayImg(data: interfaces.IFile): void {
    if (AvatarDisplayComponent.memoisedAvater.has(data._id)) {
      this.avatarLink = AvatarDisplayComponent.memoisedAvater.get(data._id);
    } else {
      this.fileService.download(data._id, this.progress).subscribe({
        next: ({ blob }) => {
          void this.blobtobase64(blob)
            .then((b64: string) => {
              AvatarDisplayComponent.memoisedAvater.set(data._id, b64);
              this.avatarLink = b64;
            })
            .catch(() => {
              this.avatarLink = this.defaulAvatarLink;
            });
        },
        error: () => {
          this.avatarLink = this.defaulAvatarLink;
        }
      });
    }
  }

  private blobtobase64(blob: Blob): Promise<string> {
    try {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      return new Promise((resolve) => {
        reader.onloadend = () => {
          resolve(reader.result as string);
        };
      });
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
